import { createTheme } from "@material-ui/core/styles";
import { colours } from "./styles/colours";

export const theme = createTheme({
  palette: {
    primary: {
      main: colours.primaryBlue,
      contrastText: colours.white,
    },
    success: {
      main: colours.green,
    },
    error: { main: colours.red },
    background: {
      default: colours.grey,
    },
    warning: {
      main: colours.yellow,
    },
  },
  typography: {
    fontFamily: "Helvetica Neue",
    fontWeightRegular: 300,
    body1: {
      fontSize: "1em",
    },
  },
  overrides: {
    MuiFormControl: {
      root: {
        marginTop: 8,
        fontSize: "1em",
      },
    },
    MuiFormLabel: {
      root: {
        fontSize: "1em",
        color: colours.darkGrey,
      },
    },
    MuiStepIcon: {
      root: {
        color: colours.primaryBlue,
      },
    },
    MuiInputBase: {
      root: {
        fontSize: "1em",
        borderRadius: "6px",
        background: colours.white,
        "&$focused": {
          borderColor: colours.primaryBlue,
          color: colours.primaryBlue,
          background: colours.white,
        },
      },
      input: {
        borderColor: colours.lightGrey,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: "1em 1.2em",
      },
      adornedEnd: {
        paddingRight: ".5em",
      },
    },
    MuiStepper: {
      root: {
        borderRadius: "5px",
        padding: "12px",
      },
    },
    MuiStepLabel: {
      iconContainer: {
        fontSize: "2em",
      },
      labelContainer: {
        fontSize: "1em",
      },
    },
    MuiStepContent: {
      root: {
        marginLeft: "0.6em",
      },
    },
    MuiStepConnector: {
      vertical: {
        marginLeft: "0.6em",
      },
    },
    MuiFormHelperText: {
      root: {
        fontSize: "1em",
      },
    },
    MuiSlider: {
      markLabel: {
        fontSize: "0.75em",
      },
    },
    MuiInputLabel: {
      outlined: {
        transform: "translate(1em, 1.2em) scale(1)",
        width: "calc(100% - 4em)",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "left",
      },
    },
    MuiSvgIcon: {
      root: {
        fontSize: "1em",
        transition:
          "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      },
    },
    MuiCheckbox: {
      root: {
        color: colours.black,
      },
    },
    MuiButton: {
      root: {
        fontSize: "1em",
        boxShadow: "none",
      },
      contained: {
        boxShadow: "none",
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: "none",
        fontSize: "1em",
      },
      head: {
        color: "inherit",
        lineHeight: "1.7142857142857142em",
      },
      body: {
        border: "none",
        color: "inherit",
        padding: "1em",
      },
    },
    MuiTablePagination: {
      root: {
        color: "inherit",
        fontSize: "1em",
      },
      toolbar: {
        padding: 0,
      },
      selectRoot: {
        marginLeft: "0.5em",
        marginRight: "1.5em",
      },
    },
    MuiTypography: {
      body2: {
        fontSize: "1em",
      },
      body1: {
        fontSize: "1.1428571428571428em",
      },
    },
    MuiIconButton: {
      root: {
        fontSize: "1.7142857142857142em",
      },
    },
  },
});
